import { EM_DASH } from "routes/custom_tables/grid/cellHelpers";
import { choiceColor } from "routes/custom_tables/choiceHelpers";
import ChoiceChip from "routes/custom_tables/grid/cells/ChoiceChip";

export default function SingleSelectCell({ value, column }) {
  return value == null || value === "" ? (
    <span className="tw:text-muted-foreground">{EM_DASH}</span>
  ) : (
    <ChoiceChip label={value} color={choiceColor(column?.options, value)} />
  );
}
